export default __webpack_public_path__ + "static/media/m.1dea938b.jpg";